import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { UncontrolledTooltip, Table, Modal, ModalHeader, ModalBody, ModalFooter, Button } from 'reactstrap';
import { Paginacion } from './Paginacion';

import Swal from 'sweetalert2'
import withReactContent from 'sweetalert2-react-content'

const TITLE = "Reportes de Retroalimentación Estudiantil";
const APIURL = process.env.REACT_APP_API_URL;


const MySwal = withReactContent(Swal)

export class ParalelosMateria extends Component {
    static displayName = ParalelosMateria.name;

    constructor(props) {
        super(props);
        this.state = { total: 0, page: 1, size: 10, codigo: "", paralelos: [], loading: true };
        this.handlePage = this.handlePage.bind(this);
        this.toggle = this.toggle.bind(this);
    }

    componentDidMount() {
        document.title = TITLE + " - Histórico por materia";
        const codigo = this.props.match.params["codigo"];
        const page = parseInt(this.props.match.params["page"]) || 1;
        const size = parseInt(this.props.match.params["size"]) || 10;
        this.populateData(codigo, page, size);
    }

    componentDidUpdate() {
        const codigo = this.props.match.params["codigo"];
        const page = parseInt(this.props.match.params["page"]) || 1;
        const size = parseInt(this.props.match.params["size"]) || 10;
        if (page != this.state.page) {
            this.populateData(codigo, page, size);
        }

    }

    handlePage(url, page, size) {
        this.setState({ loading: true }, () => {
            this.props.history.push(`${url}/${page}/${size}`);
        });
    }

    toggle(paralelo) {
        const i = this.state.paralelos.indexOf(paralelo);

        if (!paralelo.verpdf) {
            MySwal.fire({
                title: 'Generando PDF...',
                allowOutsideClick: false,
                didOpen: () => {
                    MySwal.showLoading();
                }
            });

            fetch(`${APIURL}/api/reportes/reporte-paralelo-pdf/${paralelo.anio}/${paralelo.termino}/${paralelo.codigo}/${paralelo.paralelo}/${paralelo.cedula}/${paralelo.idnivelformacion}`)
                .then(response => response.json())
                .then(data => {
                    this.setState(({ paralelos }) => ({
                        paralelos: [
                            ...paralelos.slice(0, i),
                            {
                                ...paralelos[i],
                                verpdf: !paralelos[i].verpdf,
                                datapdf: data.result
                            },
                            ...paralelos.slice(i + 1)
                        ]
                    }));
                    MySwal.close();
                })
                .catch(error => {
                    Swal.fire({
                        icon: 'error',
                        title: 'Error',
                        text: 'No se pudo generar el PDF.',
                        allowOutsideClick: false
                    });
                });
        }
        else {
            this.setState(({ paralelos }) => ({
                paralelos: [
                    ...paralelos.slice(0, i),
                    {
                        ...paralelos[i],
                        verpdf: !paralelos[i].verpdf,
                    },
                    ...paralelos.slice(i + 1)
                ]
            }));

        }
    }

    formatter(valor) {
        return new Intl.NumberFormat('en-US', { minimumFractionDigits: '2', maximumFractionDigits: '2', signDisplay: 'never' }).format(valor)
    }

    renderTable(paralelos) {
        return (
            <Table responsive={true} striped={true}>
                <thead>
                    <tr>
                        <th className="text-center col-1" scope="col">Año</th>
                        <th className="text-center col-1" scope="col">Término</th>
                        <th className="text-center col-1" scope="col">Nivel</th>
                        <th className="text-center col-5" scope="col">Docente</th>
                        <th className="text-center col-1" scope="col">Paralelo</th>
                        <th className="text-center col-1" scope="col">% Respuestas</th>
                        <th className="text-center col-1" scope="col">Calificación</th>
                        <th className="col-1" scope="col">{' '}</th>
                    </tr>
                </thead>
                <tbody>
                    {paralelos.map((p, index) => {
                        const porcentaje = Math.round(p.evaluados * 100 / p.registrados);
                        return (
                            <tr key={index}>
                                <td className="text-center">{p.anio}</td>
                                <td className="text-center">{p.termino}</td>
                                <td className="text-center">{p.nivel}</td>
                                <td>{p.apellidos} {p.nombres}</td>
                                <td className="text-center">{p.paralelo}</td>
                                <td className="text-center">
                                    <span id={"tt_" + index} >{porcentaje}%</span>
                                    <UncontrolledTooltip placement="right" target={"tt_" + index}>
                                        {p.evaluados}/{p.registrados}
                                    </UncontrolledTooltip >
                                </td>
                                <td className="text-center">{p.evaluados > 0 ? this.formatter(p.promedio) : "-"}</td>
                                <td style={{ display: 'flex', gap: '0.5rem' }}>                                    
                                    {p.evaluados > 0 && (<>
                                        <Link className="btn btn-secondary" to={`/paralelo/${p.anio}/${p.termino}/${p.codigo}/${p.paralelo}/${p.cedula}`}>Detalle</Link>

                                        <Link className="btn btn-secondary" to="#" onClick={() => this.toggle(p)}>PDF</Link>
                                        <Modal isOpen={p.verpdf} className="modal-xl">
                                            <ModalHeader>Detalle Paralelo</ModalHeader>
                                            <ModalBody>
                                                <embed src={`data:application/pdf;base64,${p.datapdf}`} width={1100} height={600} type='application/pdf' pluginspage="http://www.adobe.com/products/acrobat/readstep2.html" />
                                            </ModalBody>
                                            <ModalFooter>
                                                <Button color="secondary" onClick={() => this.toggle(p)}>Cerrar</Button>
                                            </ModalFooter>
                                        </Modal>
                                    </>)}                      
                                </td>
                            </tr>
                        );
                    })}
                </tbody>
                <tfoot>
                    <tr>
                        <td colSpan={8}>
                            <Paginacion total={this.state.total} page={this.state.page} size={this.state.size} url={`/paralelos-materia/${this.state.codigo}`} handle={this.handlePage} />
                        </td>
                    </tr>
                </tfoot>
            </Table>
        );
    }

    render() {
        let contents = this.state.loading
            ? <p><em>Loading...</em></p>
            : this.renderTable(this.state.paralelos);

        return (
            <div>
                <h1 id="tabelLabel" >Histórico por materia</h1>
                <h2>Materia: <strong>{this.state.paralelos && this.state.paralelos.length > 0 && this.state.paralelos[0].codigo + " " + this.state.paralelos[0].materia}</strong></h2>
                {contents}
            </div>
        );
    }

    async populateData(codigo, page = 1, size = 10) {
        const response = await fetch(`${APIURL}/api/reportes/paralelos-materia/${codigo}/${page}/${size}`);
        const data = await response.json();
        if (data && data.total && data.datos) {
            const paralelos = data.datos.map(p => ({ ...p, verpdf: false, datapdf: "" }));

            this.setState({ total: data.total, page: page, size: size, codigo: codigo, paralelos: paralelos, loading: false });
        }
    }
}
